module.exports = __webpack_public_path__ + "static/bache-31a32b60c5cc98ea4a404ded107ae98e.jpg";